module.exports = __webpack_public_path__ + "img/search.590f1e0f.svg";